import { getToken } from 'app/utils'
import { API_GetConfig } from 'app/api'


//Defines types used to make requests and handle responses.

type Request<X, Y, Z> = {
	config?: API_GetConfig,
	type?: 'GET' | 'POST'
	baseUrl?: string
	endpoint?: string,
	params?: X,
	output?: RequestOutput<Y, Z>,
	headers?: any
}
type ResponseOutput = {
	message: string
	success: boolean
	total?: number
}
type ResponseErrorOutput = {
	message: string
	success: boolean
}

export type RequestOutput<Y, Z> = {
	response?: (data: ResponseOutput & Y) => void,
	error?: (error: (RequestError | Z) & ResponseErrorOutput, message: string) => void
}


//Request errors.
//Defines the different types of error that can occur if the API is not available.

export enum RequestError {
	APIUnavailable = 'API with the provided name doesn\'t exist',
	GenericError = 'API responded with an error',
}


//Request config.
//Create the axios object to make HTTP requests and sets common configuration.

export default async function executeRequest(request: Request<any, any, any>) {
	const axios = require('axios')

	if (request.endpoint == null) {
		console.error('Missing parameter "endpoint". Aborting.')
		return
	}

	request.baseUrl = request.baseUrl ?? request.config?.app.serverUrl
	if (request.baseUrl == null) {
		console.error('Parameter "baseUrl" not provided in the request. Aborting.')
		return
	}

	if (request.type == null) request.type = 'POST'

	const instance = axios.create({
		baseURL: request.baseUrl,
	})
	const config = {
		headers: {
			'Content-type': 'multipart/form-data',
		}
	}

	const authToken = getToken()
	if (authToken != null && request.params != null) request.params['token'] = authToken

	let data = new FormData()
	if (request.params != null) {
		Object.keys(request.params).forEach((k, i) => {
			data.append(k, (request.params as any)[k])
		})
	}

	try {
		let response: any = null
		if (request.type === 'GET') response = await instance.get(request.endpoint, data, config)
		else if (request.type === 'POST') response = await instance.post(request.endpoint, data, config)

		if (response.data.error) {
			//console.error('Response error: ', response.data.error)
			if (request.output?.error) request.output?.error(response.data, response.data.error)
			return
		}

		if (response.data) {
			//console.log('Response: ', response)
			if (request.output?.response) {
				if (response.data.success === false && request.output?.error) request.output?.error(response.data, response.data.message)
				else request.output?.response(response.data)
			}
		}
	}
	catch (error) {
		//console.error('Request error: ', error)
		if (request.output?.error) request.output?.error(RequestError.APIUnavailable, error as any)
	}
}